import type {
  InteractiveContent,
  Range,
  ScaleResult,
} from '@core-api/presentation/types/response';
import {
  SCALES_FALLBACK_MIN_RANGE,
  SCALES_FALLBACK_MAX_RANGE,
} from '../utils/constants';

export interface ScalesPreviewResults {
  results: ScaleResult[];
}

const INITIAL_RESULTS: ScalesPreviewResults = {
  results: [],
};

export const getScalesPreviewResultsIteration = ({
  previous = INITIAL_RESULTS,
  iteration,
  choices,
  range,
}: {
  previous: ScalesPreviewResults | undefined;
  iteration: number;
  choices: InteractiveContent['choices'];
  range: Range | null;
}): ScalesPreviewResults => {
  const rangeMin = range?.min ?? SCALES_FALLBACK_MIN_RANGE;
  const rangeMax = range?.max ?? SCALES_FALLBACK_MAX_RANGE;
  if (iteration === 0 || previous.results.length === 0) {
    return {
      results: choices.map(({ interactiveContentChoiceId }) => {
        const scaleResults = [];
        for (let j = rangeMin; j <= rangeMax; j++) {
          scaleResults.push({ value: j, responseCount: 0, participants: [] });
        }
        return {
          interactiveContentChoiceId,
          scaleResults,
          skips: 0,
        };
      }),
    };
  } else {
    const respondentsToAdd = Math.floor(Math.random() * 3) + 1;
    return {
      results: previous.results.map((previousResult) => {
        const randomValue =
          Math.floor(Math.random() * (rangeMax - rangeMin + 1)) + rangeMin;
        const scaleResults = previousResult.scaleResults.map((scaleResult) => {
          if (scaleResult.value === randomValue) {
            return {
              ...scaleResult,
              responseCount: scaleResult.responseCount + respondentsToAdd,
            };
          }
          return scaleResult;
        });
        return {
          interactiveContentChoiceId: previousResult.interactiveContentChoiceId,
          scaleResults,
          skips: 0,
        };
      }),
    };
  }
};
